import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
  Configuration 
} from '@azure/msal-browser';
import {
  MsalInterceptor,
  MSAL_INSTANCE,
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
} from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withFetch } from '@angular/common/http';
import { AccessTokenInterceptor } from './interceptors/access-token.interceptor';
import { DatePipe } from '@angular/common';

export function loggerCallback(_logLevel: LogLevel, message: string) {
  
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    environment.apiConfig.uri,
    environment.apiConfig.scopes
  );
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes],
    },
    loginFailedRoute: '/login',
  };
}


const B2C_CONFIG: Configuration = {
  auth: {
    clientId: environment.b2cPolicies.clientId, // This is the ONLY mandatory field that you need to supply.
    authority: environment.b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
    knownAuthorities: [environment.b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/processing', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
    postLogoutRedirectUri: '/login', // Points to window.location.origin by default.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        if(environment && environment.envType=='local'){
        }
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
    tokenRenewalOffsetSeconds: 300,
  },
}

const SSO_CONFIG: Configuration = {
  auth: {
    clientId: environment.msalConfig.auth.clientId,
    authority: environment.msalConfig.auth.authority,
    redirectUri: '/processing',
    postLogoutRedirectUri: '/login',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback,
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
    tokenRenewalOffsetSeconds: 300,
  },
}

export function MSALInstanceFactory(isB2C: boolean): PublicClientApplication {
  const config = isB2C ? B2C_CONFIG : SSO_CONFIG;
  return new PublicClientApplication(config);
}

export function MSALInstanceFactoryMain(isB2C: boolean): IPublicClientApplication {
  let  config:any = {}
  let getLoginType = localStorage.getItem('logintype')
  if(getLoginType){
     config = getLoginType=='b2c' ? B2C_CONFIG : SSO_CONFIG;
  }
  else{
     config = isB2C ? B2C_CONFIG : SSO_CONFIG;
  }
  return new PublicClientApplication(config);
}

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },{
      provide: HTTP_INTERCEPTORS,
      useClass: AccessTokenInterceptor, // This will be executed after InterceptorOne
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: (data:boolean=false) => MSALInstanceFactoryMain(data),
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ]
  
};
